import React, { useState, useEffect } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { MdOutlineEdit } from "react-icons/md";


export const PostOpening = () => {
    const { setLoading } = useLoading();
    const [postList, setPostList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [showNoticeModal, setShowNoticeModal] = useState(false);
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });

    const handleFormOpen = () => {
        setShowForm(true);

    }

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }

    const [formData, setFormData] = useState({
        post_date: getTodayDate(),
        post_description: '',
        exp_required: '',
        role: ''
    })

    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const resetForm = () => {
        setFormData({
            post_date: getTodayDate(),
            post_description: '',
            exp_required: '',
            role: ''
        });
        setShowForm(false);
        setIsEditMode(false)

    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isEditMode) {
            try {
                await axios.put(`https://api.skyguard.group/api/update-post-opening/${formData.id}`, formData);

                showToast('Opening Update Successfully', 'success');

                await fetchOpenings();
                resetForm();
            } catch (error) {
                console.error(error);
                showToast('Error Updating Notice', 'danger');
            }

            setIsEditMode(false);
        } else {
            try {
                const res = await axios.post('https://api.skyguard.group/api/post-opening', formData);
                showToast('Opening Posted Successfully', 'success');
                console.log(res);

                setPostList(prev => [
                    ...prev,
                    { id: res?.data?.insertId, ...formData }
                ]);

                await fetchOpenings();
                resetForm();

            } catch (error) {
                console.error(error);
                showToast('Error Adding Notice', 'danger');
            }
        }
    }


    const fetchOpenings = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/get-openings');
            const list = Array.isArray(res?.data) ? res.data : (res?.data?.result || res?.data?.data || []);
            setPostList(list);
        } catch (error) {
            console.error("Error fetching Notices", error);
            setPostList([]);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchOpenings();
    }, [])

    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };


    const handleEdit = (form) => {
        setFormData({
            id: form.id || '',
            post_date: form.date ? form.date.split(' ')[0] : '',
            post_description: form.description || '',
            exp_required: form.exp || '',
            role: form.role || '',
        });

        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };


    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.skyguard.group/api/delete-opening/${id}`);
            showToast('Opening removed successfully.', 'success');
            fetchOpenings();
            setPostList(prev => prev.filter(item => item.id !== id));
        } catch (error) {
            console.error('Error deleting loan:', error);
            showToast('Failed to delete Opening', 'danger');
        }
    }


    return (
        <>

            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

                    <div className='d-flex justify-content-between'>
                        <h3 className='my-2 fw-bold fs-5 golos'>Post Openings</h3>

                        <button className='btn btn-success my-2' onClick={handleFormOpen}>
                            <AiOutlinePlusCircle size={20} /> Add New
                        </button>
                    </div>

                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>


                                                      {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.post_date}
    </span>
  </div>
)}
                                <div className='row g-3'>

                                    {/* Notice Apply Date< */}
                                    <div className="col-md-6">
                                        <label htmlFor='post_date' className="form-label fw-medium">Hirings From</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="post_date"
                                            id='post_date'
                                            value={formData.post_date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label htmlFor='role' className="form-label fw-medium">Role</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="role"
                                            id='role'
                                            value={formData.role}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label htmlFor='exp_required' className="form-label fw-medium">Experience Required (in Years)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="exp_required"
                                        id='exp_required'
                                        value={formData.exp_required}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className='col-12 mt-3'>
                                    <label htmlFor='post_description' className="form-label fw-medium">Job Description </label>
                                    <textarea
                                        className="form-control"
                                        name="post_description"
                                        id='post_description'
                                        placeholder="Enter description here... (For new line seperate by | here)"
                                        rows="7"
                                        value={formData.post_description || ''}
                                        onChange={handleChange}
                                    />
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={() => {
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}


                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                    <th>Posted On</th>
                                    <th>Role</th>
                                    <th>Exp Required</th>
                                    <th>Job Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {postList.length > 0 ? (
                                    postList.map((notice, idx) => (
                                        <tr key={idx} className='bg-white'>
                                            <td>{idx + 1}</td>
                                            <td>
                                                {new Date(notice.date).toLocaleDateString('en-GB')}
                                            </td>
                                            <td>{notice.role}</td>
                                            <td>{notice.exp}</td>
                                            <td 
                                                className="text-wrap"
                                                style={{ maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-word" }}
                                            >
                                                {(notice.description || '')
                                                    .split('|')
                                                    .map((text, index) => (
                                                        <div key={index}>● {text.trim()}</div>
                                                    ))}
                                            </td>
                                            <td>
                                                <button
                                                    className='btn btn-sm btn-danger bg-danger '
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Remove this Opening',
                                                            message: `Are you sure you want to remove this opening ?`,
                                                            onConfirm: () => handleDelete(notice.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                                <button className='btn btn-sm btn-warning mx-2' onClick={() => handleEdit(notice)}><MdOutlineEdit size={18} /> </button>
                                            </td>
                                        </tr>
                                    ))) :
                                    <tr>
                                        <td colSpan="6" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                }
                            </tbody>



                        </table>
                    </div>

                </div>
            </div>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
        </>
    )
}
